import React, { useContext, useMemo, useState } from 'react'
import { injectIntl } from 'react-intl'
import { UserContext, NotifyContext, PdaContext } from 'context'
import { Form, Input, Button, Icon, Checkbox, Loader } from 'semantic-ui-react'
import ModalWindow from '../../../ModalWindow'
import api from '../../../../actions/api'

import './DriverEditModal.css'

import doRequest from 'actions/doRequest'

const emptyDriverEntity = {
    firstName: '',
    lastName: '',
    rfid: '',
    active: false,
    phones: [],
    driversLicense: '',
    patronymic: ''
}
const phoneValidator = /^0[0-9]{0,9}/
const phoneCheck = /^0[0-9]{9}/

function DriverEditModal(props) {
    const { type, id, intl, onEditUsers, hide } = props
    const { logout } = useContext(UserContext)

    const translates = useMemo(() => {
        return ({
            editDrivereTitle: intl.formatMessage({ id: 'title.editDriver' }),
            addDriverTitle: intl.formatMessage({ id: 'btn.addDriver' }),
            firstNameInput: intl.formatMessage({ id: 'user.firstName' }),
            lastNameInput: intl.formatMessage({ id: 'user.lastName' }),
            phoneNumber: intl.formatMessage({ id: 'user.phoneNumber' }),
            activeUser: intl.formatMessage({ id: 'user.active' }),
            driversLicense: intl.formatMessage({ id: "user.driversLicense" }),
            driversLicensePlaceholder: intl.formatMessage({ id: "user.driversLicensePlaceholder" }),
            patronymic: intl.formatMessage({ id: "user.patronymic" }),
            btnCancel: intl.formatMessage({ id: 'btn.cancel' }),
            btnSave: intl.formatMessage({ id: 'btn.save' }),
            btnAdd: intl.formatMessage({ id: 'btn.add' }),
            btnEdit: intl.formatMessage({ id: 'btn.edit' })
        })
    }, [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

    const [ open, setOpen] = useState(false)
    const [ loading, setLoading ] = useState(false)
    const [ saving, setSaving ] = useState(false)
    const [ driver, setDriver ] = useState(emptyDriverEntity)

    const { pushNotify } = useContext(NotifyContext)
    const { isPda } = useContext(PdaContext)

    const onSaveUser = () => {
        if (!saving) {
            if (driver.phones?.filter(phone => phone.match(phoneCheck) === null).length) {
                pushNotify('error', 'title.error', 'msg.phoneNumberWrong')
                return
            }

            setSaving(true)

            const request = doRequest((
                type === 'edit' ? 
                    api.driver.edit({ ...driver, id: id, rfid: driver.rfid || undefined }) 
                : 
                    api.driver.add({ ...driver, rfid: driver.rfid || null })
            ), pushNotify, logout)

            request.ready.then(data => {
                if (type === 'edit') 
                    pushNotify('info', 'title.success' , 'msg.editDriverSuccess')
                else
                    pushNotify('info', 'title.success' , 'msg.addDriverSuccess')
                
                setOpen(false)
                setDriver(emptyDriverEntity)
                onEditUsers(data)
            }).catch(console.error)
            .finally(() => {
                setSaving(false)
            })
        }
    }

    const getButtons = () => [
        { title: translates.btnCancel, onClick: onClose, disabled: saving || loading, loading: false },
        { title: type === 'edit' ? translates.btnSave : translates.btnAdd, onClick: onSaveUser, color: 'green', disabled: saving || loading, loading: saving }
    ]

    const openHandler = () => {
        if (id !== undefined) {
            setLoading(true)
            const request = doRequest(api.driver.driver(id), pushNotify, logout)

            request.ready.then(data => {
                const driver = data;
                setDriver({ ...driver, /* rfid: '', */ active: Boolean(driver?.active), driversLicense: driver?.drivers_license || '' })
            }).catch(console.error)
            .finally(() => {
                setLoading(false)
            })
        }
        setOpen(true)
    }

    const onPhoneChangeHandler = (id, data) => {
        /// Валідація поля введення 
        const [valid] = data.match(phoneValidator) || ['0']
        driver.phones[id] = valid

        setDriver({ ...driver })
    }

    const onPhoneDeleteHandler = id => {
        setDriver({ ...driver, phones: driver.phones.filter((e, index) => index !== id) })
    }

    const onPhoneCreateHandler = () => {
        if (!driver.phones) driver.phones = []
        
        if (!driver.phones.includes('')) {
            driver.phones.push('')
            setDriver({ ...driver })
        }
    }

    const onClose = () => {
        if (!saving) { 
            setOpen(false) 
            setDriver({ ...emptyDriverEntity, phones: [] })
        }
    }
    
    return (
        <ModalWindow 
            open={open}
            onClose={onClose}
            onOpen={openHandler}
            title={type === 'edit' ? translates.editDrivereTitle : translates.addDriverTitle} 
            iconType={type === 'edit' ? 'edit' : 'plus'}
            trigger={
                hide ? '' : <Button className="editButton" icon><Icon name={type === 'edit' ? 'edit' : 'plus'}/><span>{type === 'edit' ? translates.btnEdit : translates.addDriverTitle}</span></Button> 
            }
            scrolling={!loading && isPda}
            actions={getButtons()}
        >
            { loading ? 
                <Loader className={"page-loader"} active inline="centered" />
            :
                <Form className="userForm">
                    <span className="userFormRow">
                        {translates.firstNameInput}: 
                        <Input 
                            className="editField" 
                            disabled={saving || loading} 
                            placeholder={translates.firstNameInput} 
                            value={driver.firstName} 
                            onChange={e => setDriver({ ...driver, firstName: e.target.value })}
                        />
                    </span>
                    <span className="userFormRow">
                        {translates.lastNameInput}: 
                        <Input 
                            className="editField" 
                            disabled={saving || loading} 
                            placeholder={translates.lastNameInput} 
                            value={driver.lastName} 
                            onChange={e => setDriver({ ...driver, lastName: e.target.value })}
                        />
                    </span>
                    <span className="userFormRow">
                        {translates.patronymic}: 
                        <Input 
                            className="editField" 
                            disabled={saving || loading} 
                            placeholder={translates.patronymic} 
                            value={driver.patronymic} 
                            onChange={e => setDriver({ ...driver, patronymic: e.target.value })}
                        />
                    </span>
                    <span className="userFormRow">
                        {translates.driversLicense}: 
                        <Input 
                            className="editField" 
                            disabled={saving || loading} 
                            placeholder={translates.driversLicensePlaceholder} 
                            value={driver.driversLicense} 
                            onChange={e => setDriver({ ...driver, driversLicense: e.target.value })}
                        />
                    </span>
                    <span className="userFormRow">
                        RFID: 
                        <Input 
                            className="editField" 
                            disabled={saving || loading} 
                            placeholder="RFID" 
                            value={driver.rfid} 
                            onChange={e => setDriver({ ...driver, rfid: e.target.value })}
                            //onClick={() => {setDriver({ ...driver, rfid: '' })}}
                        />
                    </span>
                    <span className="userFormRow">
                        {translates.phoneNumber}: 
                        <div className="phones">
                            {driver.phones?.map((phone, index) => { 
                                return (
                                    <div key={index} className="phoneField">
                                        <Input 
                                            className="editField" 
                                            disabled={saving || loading} 
                                            placeholder={translates.phoneNumber} 
                                            value={phone} 
                                            error={phone.match(phoneCheck) ? false : true}
                                            onChange={e => onPhoneChangeHandler(index, e.target.value)}
                                        />
                                        <Button className="deletePhone" disabled={saving || loading} icon><Icon name="trash alternate" onClick={() => onPhoneDeleteHandler(index)}/></Button>
                                    </div>
                                )
                            })}
                            <Button icon onClick={onPhoneCreateHandler} disabled={saving || loading}><Icon name="plus"/></Button>
                        </div>
                    </span>
                    <span className="userFormRow">
                        {/* <Checkbox 
                            className="editField" 
                            disabled={saving || loading} 
                            checked={driver.active} 
                            label={translates.activeUser}
                            onChange={(e, { checked }) => setDriver({ ...driver, active: Boolean(checked) })} 
                        /> */}
                    </span>
                </Form>
            }
        </ModalWindow>
    )
}

export default injectIntl(DriverEditModal)